export default __webpack_public_path__ + "3eff2f2c04d98cc41faa2b2eca5e2bdb.png";